module.exports = __webpack_public_path__ + "img/demo-creative-hub.bcb36be9.png";